import React, { useState, useRef } from "react";
import img1 from "./../../../Assets/Image/image 30_New.jpg";
import img2 from "./../../../Assets/Image/image 33_New.jpg";
import img3 from "./../../../Assets/Image/QRCODEHOMeNew.jpg";
import StaticCardComponent from "./StaticCardComponent.jsx";

import "./ProvidedServices.css";

const ProvidedServices = () => {
  const scrollContainerRef = useRef(null);
  const [showArrows, setShowArrows] = useState(false);

  const cards = [
    {
      imgSrc: img3,
      title:
        "The best restaurant online menu and QR-code-table-ordering social media platform",
      text: "The social media network for restaurants and foodies that gets you discovered by thousands of local food lovers. Do away with paper menus, and showcase your items and menu changes in a flexible rich social-media-like AI-driven interactive interface. Customers can order themselves through QR codes, saving you on waiter costs, and avoiding long queues at the till",
    },
    {
      imgSrc: img1,
      title: "Best digital kitchen order management system for restaurants",
      text: "No more need for expensive paper printers at each food counter that need regular servicing for paper/ink. Our AI-driven digital kitchen manages orders in a natural flow that maximises kitchen efficiencies",
    },
    {
      imgSrc: img2,
      title:
        "Delivery/Collection, subscriptions, offers, loyalty schemes, at just 0.2% and 24hrs settlement",
      text: "Handle all types of orders, Dine-in/Delivery/Collection, create food subscriptions for the first time in the world for new predictable revenue streams, and offers/loyalty schemes, for just 0.2% per transaction on our world's lowest cost contract-free EPOS. 24hrs settlement - no contract!",
    },
  ];

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const { current } = scrollContainerRef;
      const scrollAmount = direction === "left" ? -300 : 300;
      current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="FoodSelectionMainContainer">
      <div className="LandingSevices" ref={scrollContainerRef}>
        {/* Navigation Arrows (Visible only on mobile via CSS) */}
        <button
          className="carousel-arrow left-arrow"
          onClick={() => scroll("left")}
          aria-label="Scroll left"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

        <button
          className="carousel-arrow right-arrow"
          onClick={() => scroll("right")}
          aria-label="Scroll right"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>

        {cards?.map((card, idx) => (
          <StaticCardComponent key={idx} {...card} />
        ))}
      </div>
    </div>
  );
};

export default ProvidedServices;
